import React from "react";
import T from "prop-types";
import SummaryStat from "../SummaryStat";
import { number } from "../format";

export default function Summary({ stats }) {
  return (
    <div>
      <SummaryStat
        label="Sold in 12 Mos"
        value={number(stats.sold_in_12_months)}
      />
      <SummaryStat
        label="Sold in 4 Mos"
        value={number(stats.sold_in_4_months)}
      />
      <SummaryStat
        label="Avg #Days in Stk"
        value={number(stats.average_days_in_stock)}
      />
      <SummaryStat
        label="Avg #Times OQ pr/mo"
        value={number(stats.average_oq_per_month)}
      />
    </div>
  );
}

Summary.propTypes = {
  stats: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/PartStats/Summary.jsx